export function isArray(object: any): object is any[] {
    return Array.isArray(object);
}

export function isBoolean(object: any): object is boolean {
    return typeof object === 'boolean';
}

export function isFunction(object: any): boolean {
    return typeof object === 'function';
}

export function isNull(object: any): object is null {
    return object === null;
}

export function isNullOrUndefined(object: any): object is null | undefined {
    return object === null || object === undefined;
}

export function isNumber(object: any): object is number {
    return typeof object === 'number';
}

export function isObject(object: any): boolean {
    return object !== null && typeof object === 'object';
}

export function isPrimitive(object: any): boolean {
    return (typeof object !== 'object' && typeof object !== 'function') || object === null;
}

export function isString(object: any): object is string {
    return typeof object === 'string';
}

export function isSymbol(object: any): object is symbol {
    return typeof object === 'symbol';
}

export function isUndefined(object: any): object is undefined {
    return object === undefined;
}

export function kFormatter(num: number, decimal = 2) {
    function toDecimalStr(value) {
        let str = (Math.abs(value) / 1000).toFixed(1).replace(/([0]+)$/, "");
        try {
            if (str.endsWith(".")) str += '0';
        } catch (e) {
            str += '0';
        }

        str = str.split('.')[0].length > 1 ? str.split('.')[0] : str;
        return str + 'k';
    }

    const numValue = (Math.abs(num) / 1000);
    const fixedValue = numValue.toFixed(decimal);
    decimal = decimal === 1 && Math.abs(num) > 10000 ? 1 : decimal;
    return Math.abs(num) > 999 ? Math.abs(num) > 99000 ? '>99k' : decimal === 1 ? toDecimalStr(num) : (fixedValue).replace(/\.0+$/, '') + 'k' : Math.sign(num) * Math.abs(num);
}

export function formatSizeUnits(bytes: any): any {
    if (!isNaN(bytes)) {
        if (bytes >= 1073741824) {
            bytes = (bytes / 1073741824).toFixed(2) + ' GB';
        } else if (bytes >= 1048576) {
            bytes = (bytes / 1048576).toFixed(2) + ' MB';
        } else if (bytes >= 1024) {
            bytes = (bytes / 1024).toFixed(2) + ' KB';
        } else if (bytes === 1) {
            bytes = (bytes / 1024).toFixed(2) + ' KB';
        } else if (bytes < 1024) {
            bytes = (bytes / 1024).toFixed(2) + ' KB';
        } else {
            bytes = '0.00 KB';
        }
    }
    return bytes;
}

export function validateIP(ipAddress: string): boolean {
    return isIP(ipAddress);
}

export function isIP(ipAddress: string): boolean {
    if (ipAddress.localeCompare('localhost') === 0) return true;
    return (/^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/.test(ipAddress));
}

export function createOrgNameOrIdRoleHandles(orgNamesOrIds, roleHandles, isDoubleQuoted = false): any {
    const orgNameOrIdRoleHandles = {};
    for (let i = 0; i < orgNamesOrIds.length; i++) {
        const orgNameOrId = orgNamesOrIds[i];
        const roleHandle = roleHandles[i];

        // Check if the orgNameOrId already exists in the object
        if (isDoubleQuoted) {
            orgNameOrIdRoleHandles[`"${orgNameOrId}"`] = roleHandle;
        } else {
            if (orgNameOrId in orgNameOrIdRoleHandles) {
                orgNameOrIdRoleHandles[orgNameOrId] += `, ${roleHandle}`;
            } else {
                orgNameOrIdRoleHandles[orgNameOrId] = roleHandle;
            }
        }
    }
    return orgNameOrIdRoleHandles;
}

export function areArraysOfObjectsEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) {
        return false;
    }

    for (let i = 0; i < arr1.length; i++) {
        const keys1 = Object.keys(arr1[i]);
        const keys2 = Object.keys(arr2[i]);

        if (keys1.length !== keys2.length) {
            return false;
        }

        for (const key of keys1) {
            if (arr1[i][key] !== arr2[i][key]) {
                return false;
            }
        }
    }

    return true;
}

export function convertTicksToDate(pTicks) {
    try {
        const d = new Date()
        const n = d.getTimezoneOffset();

        const actualDate = new Date(1970, 0, 1);
        actualDate.setMilliseconds(pTicks);
        actualDate.setHours(actualDate.getHours() + (Math.floor(Math.abs(d.getTimezoneOffset() / 60)) * (d.getTimezoneOffset() < 0 ? 1 : -1)));
        return actualDate;
    }
    catch (Err) {
        return "NAN";
    }
}

export function sortList(array, param, desc) {
    const members = param ? param.split('.') : ['name'];

    array.sort((a, b) => {
        let left = a;
        let right = b;

        members.forEach(entry => {
            left = left[entry];
            right = right[entry];
        });

        const leftValue = typeof left === 'string' ? left.toLowerCase() : left;
        const rightValue = typeof right === 'string' ? right.toLowerCase() : right;

        if (leftValue > rightValue) {
            return desc ? -1 : 1;
        } else if (leftValue < rightValue) {
            return desc ? 1 : -1;
        }
        return 0;
    });
}

export function getErrorMessageFromHtmlResponse(htmlErrorMsg: string): string {
    let errorMessage = null;
    if (htmlErrorMsg?.includes('<html>')) {
        errorMessage = htmlErrorMsg.replace(/<\/?[^>]+(>|$)/g, '');
        errorMessage = errorMessage.replace('Error report', '');
        errorMessage = errorMessage.replace(': null', '');
        errorMessage = errorMessage.replace(':', '');
    }
    return errorMessage;
}

